<section class="flex flex-col w-full employer-deposit">
  <div class="w-full py-4 block sm:hidden">
    <go-back></go-back>
  </div>
  <div class="text-center pb-8 md:pb-20">
    <h1 class="outfit extra-bold heading-large">{{ employerDeposit.title | translate }}</h1>
  </div>
  <div class="w-full flex flex-col justify-between items-start md:flex-row gap-8 sm:pb-10">
    <div class="flex w-full justify-center items-center flex-col gap-8 sm:gap-4">
      <p class="paragraph-medium font-normal text-center md:text-justify inline-block outfit">
        {{ employerDeposit.makeTheMost | translate }}
        <span class="font-bold">{{ employerDeposit.effectiveWay | translate }}</span>
        {{ employerDeposit.hardEarned | translate }}
      </p>
      <div class="w-72 h-auto">
        <img [src]="employerDeposit.illustrationMobile" alt="" class="w-full block md:hidden object-cover" />
      </div>
      <p class="paragraph-medium font-normal text-center md:text-justify inline-block outfit">
        {{ employerDeposit.directDeposit | translate }}
        <span class="font-bold">{{ employerDeposit.areSecure | translate }}</span>
        {{ employerDeposit.availabeForUse | translate }}
        <span class="font-bold">{{ employerDeposit.readyToUse | translate }}</span>
      </p>
    </div>
    <div class="w-full flex justify-center items-center">
      <img [src]="employerDeposit.illustration" alt="" class="w-full hidden md:block object-cover" />
    </div>
  </div>
  <img
    [src]="selectedLanguage === 'es' ? employerDeposit.depositFormatSpanish : employerDeposit.depositFormat"
    alt=""
    class="max-w-full h-auto object-cover"
  />
  <div
    class="px-4 py-6 sm:py-8 sm:px-6 mt-6 sm:mt-8 mb-14 w-full flex justify-between items-center direct-deposit cursor-pointer"
    (click)="openPdf()"
  >
    <p class="paragraph-medium outfit font-medium">{{ employerDeposit.authorisationForm | translate }}</p>
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.24992 5C5.28344 5 4.49996 5.7835 4.49996 6.75V18.25C4.49996 19.2165 5.28344 20 6.24992 20H17.7496C18.7161 20 19.4996 19.2165 19.4996 18.25V14.25C19.4996 13.8358 19.8354 13.5 20.2496 13.5C20.6638 13.5 20.9995 13.8358 20.9995 14.25V18.25C20.9995 20.0449 19.5445 21.5 17.7496 21.5H6.24992C4.45504 21.5 3 20.0449 3 18.25V6.75C3 4.95507 4.45504 3.5 6.24992 3.5H10.2498C10.664 3.5 10.9998 3.83579 10.9998 4.25C10.9998 4.66421 10.664 5 10.2498 5H6.24992ZM12.9997 4.25C12.9997 3.83579 13.3355 3.5 13.7497 3.5H20.25C20.6642 3.5 21 3.83579 21 4.25V10.75C21 11.1642 20.6642 11.5 20.25 11.5C19.8358 11.5 19.5 11.1642 19.5 10.75V6.06074L14.28 11.2804C13.9871 11.5732 13.5123 11.5732 13.2194 11.2803C12.9265 10.9874 12.9265 10.5125 13.2194 10.2196L18.4395 5H13.7497C13.3355 5 12.9997 4.66421 12.9997 4.25Z"
        fill="#505760"
      />
    </svg>
  </div>
</section>
